import { render, staticRenderFns } from "./FormResidentialOther.vue?vue&type=template&id=19b382d1&scoped=true&lang=pug&"
import script from "./FormResidentialOther.vue?vue&type=script&lang=js&"
export * from "./FormResidentialOther.vue?vue&type=script&lang=js&"
import style0 from "./FormResidentialOther.vue?vue&type=style&index=0&id=19b382d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b382d1",
  null
  
)

export default component.exports